// Enums
import { FolderableType } from 'FoldersApp/enums/folderable-type.enum';
// Services
import { SelectedFolderableService } from 'FoldersApp/services/selected-folderable.service';
// NgRx
import { setChartId } from '../state/reducers/chart-id/chart-id.actions';
import * as i0 from "@angular/core";
export class SelectedFundChartService extends SelectedFolderableService {
    constructor() {
        super(...arguments);
        this.RESOURCE_TYPE = FolderableType.FUND_CHART;
        this.ITEM_ID_SLICE_KEY = 'chartId';
    }
    clearSelection() {
        super.clearSelection();
        this.store.dispatch(setChartId({
            chartId: null,
        }));
    }
}
SelectedFundChartService.ɵfac = /*@__PURE__*/ (() => { let ɵSelectedFundChartService_BaseFactory; return function SelectedFundChartService_Factory(__ngFactoryType__) { return (ɵSelectedFundChartService_BaseFactory || (ɵSelectedFundChartService_BaseFactory = i0.ɵɵgetInheritedFactory(SelectedFundChartService)))(__ngFactoryType__ || SelectedFundChartService); }; })();
SelectedFundChartService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SelectedFundChartService, factory: SelectedFundChartService.ɵfac });
